import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [import('./viewer/PopupPage' /* webpackChunkName: "PopupPage" */)],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('PopupPage', UiTypes),
};

export default entry;
